import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import styles from './Button.scss';
import GameIcon from './game-bw-icon.svg?props[]=className:Button__media-icon';
import BookIcon from './book-bw-icon.svg?props[]=className:Button__media-icon';
import VideoIcon from './video-bw-icon.svg?props[]=className:Button__media-icon';
import ArrowIcon from './button-arrow.svg?props[]=className:Button__cta-icon';
import AgainIcon from './button-again.svg?props[]=className:Button__cta-icon';
import ShoppingIcon from './shopping-bw-icon.svg?props[]=className:Button__shopping-icon';

class Button extends Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    if (this.props.clickHandler) this.props.clickHandler(e);
  }

  render() {
    const allowedMediaIcons = {
      game: <GameIcon />,
      book: <BookIcon />,
      video: <VideoIcon />,
      series: <VideoIcon />,
    };

    const mediaLabels = {
      game: 'Play Now',
      book: 'Read Now',
      video: 'Watch Now',
      series: 'Watch Series',
    };

    const actionIcon = iconType => {
      switch (iconType) {
        case 'arrow':
        case 'buy':
          return <ArrowIcon />;
          break;
        case 'again':
          return (
            <AgainIcon className="Button__cta-icon Button__cta-icon--again" />
          );
          break;
        default:
          return <ArrowIcon />;
      }
    };

    const actionClass = this.props.withAction ? ' Button--with-action' : '';
    const sizeClass =
      typeof this.props.buttonSize !== 'undefined'
        ? ' Button--' + this.props.buttonSize
        : '';
    const contextClass =
      typeof this.props.buttonContext !== 'undefined'
        ? ' Button--' + this.props.buttonContext
        : '';
    const buttonClass =
      'Button' +
      actionClass +
      sizeClass +
      contextClass +
      this.props.customClass;
    let Icon = allowedMediaIcons[this.props.mediaType];
    if (this.props.buttonContext && this.props.buttonContext === 'buy')
      Icon = <ShoppingIcon />;
    const CTAIcon = this.props.withAction ? (
      <div className="Button__action">{actionIcon(this.props.actionIcon)}</div>
    ) : null;
    const labelText =
      this.props.mediaType && !this.props.text
        ? mediaLabels[this.props.mediaType]
        : this.props.text;
    const Label = (
      <span className="Button__label">
        {Icon}
        {labelText}
      </span>
    );

    if (this.props.to) {
      return (
        <Link to={this.props.to} className={buttonClass} onClick={this.onClick}>
          {Label}
          {CTAIcon}
        </Link>
      );
    } else if (this.props.externalLink) {
      return (
        <a
          href={this.props.externalLink}
          target="_blank"
          className={buttonClass}
          data-clickelementid={this.props.clickElementId}
          onClick={this.props.clickHandler}
        >
          {Label}
          {CTAIcon}
        </a>
      );
    } else {
      return (
        <button
          className={buttonClass}
          data-clickelementid={this.props.clickelementid}
          onClick={this.props.clickHandler}
        >
          {Label}
          {CTAIcon}
        </button>
      );
    }
  }
}

Button.propTypes = {
  text: PropTypes.string,
  buttonSize: PropTypes.string,
  buttonContext: PropTypes.string,
  customClass: PropTypes.string,
  withAction: PropTypes.bool,
  mediaType: PropTypes.string,
  to: PropTypes.string,
};

Button.defaultProps = {
  withAction: false,
  customClass: '',
};

export default Button;
